import { render } from "./PlansTable.vue?vue&type=template&id=187dc079&ts=true"
import script from "./PlansTable.vue?vue&type=script&lang=ts"
export * from "./PlansTable.vue?vue&type=script&lang=ts"

import "./PlansTable.vue?vue&type=style&index=0&id=187dc079&lang=css"

import exportComponent from "/var/www/tenanthub.au/runners/agent/root/tenanthub-agent/tenanthub-agent/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__